import { Canvas } from '@react-three/fiber'
import { ContactShadows, OrbitControls, PerspectiveCamera } from '@react-three/drei'
import type { Avatar } from '../types'
import { AvatarFigure } from './AvatarFigure'

export function AvatarPreview({ avatar, compact = false }: { avatar: Avatar; compact?: boolean }) {
  return <div className={`${compact ? 'h-44' : 'h-72'} overflow-hidden rounded-2xl border border-white/10 bg-[radial-gradient(circle_at_50%_35%,rgba(108,140,255,.25),transparent_36%),linear-gradient(155deg,#15204b,#0a1025)]`}>
    <Canvas shadows dpr={[1, 1.5]}>
      <PerspectiveCamera makeDefault position={[5, 3.6, 6]} fov={34} />
      <ambientLight intensity={1.2} />
      <directionalLight position={[4, 7, 4]} intensity={2.4} color="#dce6ff" castShadow />
      <pointLight position={[-3, 3, -3]} intensity={8} distance={8} color="#74E6C1" />
      <AvatarFigure avatar={avatar} position={[0, 0.2, 0]} scale={compact ? 0.72 : 0.98} />
      <ContactShadows position={[0, -0.28, 0]} opacity={0.45} scale={4} blur={2.5} far={3} />
      <OrbitControls enablePan={false} enableZoom={!compact} minPolarAngle={1.05} maxPolarAngle={1.65} target={[0, 1.4, 0]} />
    </Canvas>
  </div>
}
